import { createContext, useContext } from 'react';
import { DEFAULT_FLAGS } from 'src/services/FeatureFlags/FeatureFlags.constants';
import type { tFeatureFlagsContext } from './FeatureFlags.types';

/** The flag defaults now live beside `tFeatureFlags` in the service layer
 * (RET-1922) so the strict envelope parser derives its known-key list from the
 * same literal. Re-exported here because this has been the import site since
 * AGI-154; add new flag keys in `services/FeatureFlags/FeatureFlags.constants`. */
export { DEFAULT_FLAGS };

const DEFAULT_FEATURE_FLAGS_CONTEXT: tFeatureFlagsContext = {
  featureFlags: DEFAULT_FLAGS,
  isLoadingFeatureFlags: false,
  isSmartLeadBotEnabled: false,
  isOnboardingAutoSetupEnabled: false,
  isLeadAgentMetricsEnabled: false,
  isAnalyticsLakeSectionsEnabled: false,
  isAnalyticsSellerViewEnabled: false,
  isAnalyticsSellerFilterEnabled: false,
  isHomeNewsCardEnabled: false,
  isAlertCenterEnabled: false,
  isOptimizationCenterEnabled: false,
  isAlertCenterPageEnabled: false,
  isInlineSeatPurchaseEnabled: false,
  isPastDuePaymentZoneEnabled: false,
  isChallengeCompletionToastEnabled: false,
  hasLoadedFeatureFlags: false,
  refetch: async () => DEFAULT_FLAGS,
};

export const FeatureFlagsContext = createContext<tFeatureFlagsContext>(
  DEFAULT_FEATURE_FLAGS_CONTEXT,
);

export function useFeatureFlagsContext(): tFeatureFlagsContext {
  return useContext(FeatureFlagsContext);
}
